const translations = {
    header: {
        title: 'Formulario de acceso a la Matrícula Tecnocampus',
        sub_title: 'Si este es el primer año que estudias en nuestro centro, te agradeceríamos que dediques unos minutos de tu tiempo para rellenar esta encuesta.',
        description: 'Nos ayudará a planificar la acogida de tus compañeros de cursos posteriores y, en general, a mejorar la calidad de nuestros servicios.'
    },
    btns_form:{
        next: 'Siguiente',
        previous: 'Anterior',
        submit: 'Enviar'
    },
    title: 'Formulario encuesta nuevos alumnos',
    sub_title: 'Rellena el siguiente formulario',
    survey_close: {
        msg: 'Encuesta cerrada!',
        sub_msg: 'Lamentamos informar que la encuesta, Nuevo acceso a los Grados del Tecnocampus, está cerrada'
    },
    tabs:{
        personal_data: {
            title: 'Datos personales',
            name: 'Nombre',
            surname1: 'Primer apellido',
            surname2: 'Segundo apellido',
            dni: 'NIF/NIE/Pasaporte',
            phone: 'Teléfono móvil',
            gender: 'Género',
            email: 'Correo personal',
            birthday: 'Fecha nacimiento',
            grade: 'Grado que cursas',
            provincia: 'Provincia',
            population: 'Municipio de residencia',
            country: 'País',
            placeholder_country: 'Selecciona un país',
            question1: 'Si durante el curso académico no vives en tu municipio de residencia, indica en que tipo de alojamineto vives (marca una de las opciones)',
            question2_1 :'¿Compaginarás los estudios con un trabajo?',
            question2_2: 'En caso afirmativo, indica una de las siguientes opciones'
        },
        photo:{
            title: 'Fotografía',
            intro: 'Esta fotografía se utilizará para generar vuestro carnet de estudiante.',
            requirements_title: 'La fotografia tiene que cumplir los siguientes criterios, de lo contrario no podreis continuar y no podremos procesar vuestra alta correctamente:',
            requirements: [
                "El tamaño de la fotografía no puede superar como <strong>máximo 4Mb</strong> de peso",
                "La imagen ha de tener un tamaño mínimo de 176px de ancho y 220px de altura.",
                "La foto ha de ser de tipo busto. Quiere decir que la imagen NO puede ser de cuerpo entero, ni de medío cuerpo, como mucho de pecho arriba, o sólo cara, es <strong>muy importante que se vea la cara entera y que sea identificable</strong>, preferiblemente con un fondo blanco."
            ],
            instructions: 'Arrastra una imagen en el cuadro o usa el botón de \'Añadir foto\'',
            add_photo: 'Añadir fotografía',
            crop_photo: 'Recortar foto',
            remove_photo: 'Quitar la foto',
            note: 'Esta foto es la que es hará servir para tu carnet de estudiante y para el campus virtual',
            upload_photo: 'Subir fotografía',
            make_photo: 'Hacer fotografía',
            file_title: 'Foto de Carnet',
            select_webcam: 'Selecciona la cámara',
            take_snapshot: 'Capturar imagen',
            errors: {
                no_foto: "<p>No ha añadido ninguna fotografía</p>",
                mida: "<p>Recuerda: </p>" +
                    "<p>Medidas 175px de ancho y 220px de altura máxima</p>" +
                    "<p>El peso del fichero no ha de ser de mas de 4Mb</p>",
                mida_superada: 'El peso del fichero supera 4Mb o no cumple con las medidas requeridas mínimas.'
            }
        },
        academic_data: {
            title: 'Datos Académicos',
            description: 'Datos Académicos de los últimos estudios cursados',
            question1: 'Estudios cursados (indica sólo los últimos estudios que has hecho)',
            question2: 'Tipo de bachillerato cursado',
            question3: 'Centro Académico (de los últimos estudios)',
        },
        title_selection:{
            title: 'Selección Titulación/Centro',
            description: 'Selección de la Titulación y el Centro',
            question1: 'Valora de 0 (menos importante) a 10 (muy importante) los diferentes aspectos que te han ayudado a decidir a optar por cursar los estudios en el Tecnocampus',
            question2: '¿Cómo no has conocido?',
            errors: {
                missing_answers: 'Hay respuestas sin contestar'
            }
        },
        expectations:{
            title: 'Expectativas',
            description: 'Expectativas',
            question1: 'Valora de 1 (poco importante) a 5 (muy importane) los seguientes aspectos según la importancia que crees que han de tener para recibir una buena formación universitaria',
            errors: {
                missing_answers: 'Hay respuestas sin contestar'
            }
        },
        comunication: {
            title: 'Comunicación',
            description: 'Comunicación',
            question1:'Indica los canales de comunicación; a través de los cuales  te gustaría recibir información sobre tus estudios y/o la  actualidad de la universidad',
            errors: {
                missing_answers: 'Hay respuestas sin contestar'
            }
        },
        transport:{
            title: 'Transporte',
            description: 'Transporte',
            question1: 'Marca el medio de transporte que usarás para venir a estudiar al centro. Si unos dìas vienes con un medio y otros con otro diferente, marca sólo el que será más habitual.',
            errors: {
                missing_answers: 'Hay respuestas sin contestar'
            }
        },
        impressions: {
            title: 'Impresiones',
            description: 'Primeras Impresiones',
            question1: 'Valora la calidad de la información disponible sobre el proceso de matrícula (documentación que has de entregar, cuando has de venir, día y hora, lugar, etc).',
            question2: 'Valora la calidad de la información académica (información; de los estudios a cursar: planes docentes, horarios, etc) disponible antes de la matrícula',
            question3: 'Otros comentarios que quieras hacer, drigidos a la Dirección del Centro',
            policies_accepted: 'Acepto las condiciones de la <a target="_blank" href="http://www.tecnocampus.cat/ca/avis-legal">política de privacidad</a>',
            policies: '<b>Autorizo expresamente a la Fundación Tecnocampus Mataró-Maresme a tratar mis datos personales con el fin de realizar el tratamiento estadístico de las encuestas a los estudiantes de nuevo acceso.</b>\n' +
                ' Los datos personales facilitados serán incorporados al fichero de datos <b>“Encuesta a los estudiantes de nuevo acceso”</b>.\n' +
                ' Los datos estadísticos no se utilizan con nombres asociados. Estos datos sólo serán cedidos a terceros en aquellos casos en que sea necesario para el cumplimiento de las obligaciones legalmente establecidas.\n' +
                ' Le informamos que en cualquier momento podrá ejercer sus derechos de acceso, rectificación, supresión y oposición, remitiendo un escrito identificado con la referencia "Protección de Datos", en el que se acompañe una fotocopia\n' +
                ' del documento nacional de identidad del titular de los datos, y en el que conste la petición en la que se concreta la solicitud, una dirección a efectos de notificaciones, fecha y firma, en la siguiente dirección electrónica\n' +
                ' rgpd@tecnocampus.cat, o bien mediante una carta prefranqueada dirigida a la Secretaría General de la Fundación Tecnocampus Mataró-Maresme (Avenida de Ernest Lluch, 32 Edificio Universitario, 08302 Mataró).',
            errors: {
                missing_answers: 'Hay respuestas sin contestar'
            }
        },
        end:{
            title: 'End',
            thanks: 'Gracias por realizar la encuesta, aquí está su registro',
            detail1: 'Se ha enviado un email a su dirección de correo eletrónico con la confirmación del registro de la encuesta,\n' +
                '        <strong>es necesario que traer el resguardo co¡n la documentación el día de la matrícula</strong>',
            detail2: 'Si desea puede imprimir los datos de la siguiente tabla como un resguardo o si lo prefiere puede imprimir el justificante que se le ha enviado por correo',
            guard: 'Resguardo del formulario de la encuesta de matrículas de nuevo acceso a Tecnocampus',
            guard_title:'Datos del registro realizado',
            print:'Imprimir resguardo'
        }
    }
}

export default  translations;